define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FInspAssetAttr = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class FInspAssetAttr extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "InspAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CurrentValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CurrentValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onAnyChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FInspAssetAttr.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FInspAsset = parent;
            this.InspAssetId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FInspAsset = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.InspAssetId = (0, EntityUtil_1.toInt)(entity.InspAssetId);
            a.FAssetAttrId = (0, EntityUtil_1.toInt)(entity.FAssetAttrId);
            a.AttrTypeId = (0, EntityUtil_1.toInt)(entity.AttrTypeId);
            a.CurrentValue = b.CurrentValue;
            a.NewValue = b.NewValue;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.onAnyChangeBatchFn = (0, lodash_debounce_1.default)(this.onAnyChange, 1000);
            this.addChangeEventAction("NewValue", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("PersistanceState", this.onAnyChangeBatchFn.bind(this));
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FInspAssetAttr.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "InspAssetId", "Facility Asset Id");
                this.validateReqNumber(validationState, "AttrTypeId", "Asset Attribute Type Id");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                InspAssetId: this.InspAssetId,
                FAssetAttrId: this.FAssetAttrId,
                AttrTypeId: this.AttrTypeId,
                CurrentValue: this.CurrentValue,
                NewValue: this.NewValue,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onAnyChange(change) {
            if (this.FInspAsset) {
                this.FInspAsset.onAnyChange();
            }
        }
        static create(a, type) {
            return new Promise((resolve) => {
                var aa = new FInspAssetAttr(null, a);
                aa.AttrTypeId = type.Id;
                a.FInspAssetAttr.push(aa);
                resolve(aa);
            });
        }
        get AssetAttributeType() {
            if (this.FInspAsset && this.FInspAsset.FInspection && this.FInspAsset.FInspection.Facility) {
                return this.FInspAsset.FInspection.Facility.AssetAttributeTypes.find(aat => aat.Id == this.AttrTypeId);
            }
            else {
                return null;
            }
        }
        get Description() {
            if (this.AssetAttributeType) {
                return this.AssetAttributeType.Desc_;
            }
        }
    }
    exports.FInspAssetAttr = FInspAssetAttr;
    Object.defineProperty(FInspAssetAttr, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FInspAssetAttr"
    });
    Object.defineProperty(FInspAssetAttr, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Inspection Asset Attribute"
    });
    Object.defineProperty(FInspAssetAttr, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "InspAssetId", "FAssetAttrId", "AttrTypeId", "CurrentValue", "NewValue"]
    });
    Object.defineProperty(FInspAssetAttr, "InspAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAssetAttr, "FAssetAttrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAssetAttr, "AttrTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAssetAttr, "CurrentValueLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspAssetAttr, "CurrentValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAssetAttr, "NewValueLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspAssetAttr, "NewValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "InspAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "InspAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "FAssetAttrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "FAssetAttrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "AttrTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "AttrTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "CurrentValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "CurrentValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "NewValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "NewValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAssetAttr.prototype, "FInspAsset", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspAssetAttr.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspAssetAttr.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspAssetAttr.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAssetAttr.prototype, "AssetAttributeType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAssetAttr.prototype, "Description", null);
});
